import { useStableLiveQuery } from '@/src/renderer/lib/db/useStableLiveQuery'
import { db } from '@/src/renderer/lib/db/indexeddb'
import type { Goal, LifeSpace } from '@/src/renderer/lib/db/models'

/**
 * Reactive list of goals for a life space, newest-first.
 *
 * Returns `undefined` while the first query is still pending (mirrors
 * `useLiveQuery`), so callers can render a loading state. Soft-deleted
 * goals are excluded — see `db.getGoalsByLifeSpace`.
 */
export function useGoals(lifeSpace: LifeSpace): Goal[] | undefined {
  return useStableLiveQuery(() => db.getGoalsByLifeSpace(lifeSpace), [lifeSpace])
}
